import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';
import {actionButtonSx} from 'src/components/common/actionButton.sx';

export const cardSx: SxProps<Theme> = {
    background: theme.palette.common.white,
    borderRadius: '14px',
    border: '1px solid rgba(0, 0, 0, 0.05)',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.04)',
    overflow: 'hidden',
};

/** The same spine the plan's own page carries, so the link reads before it is clicked. */
export const accentBarSx: SxProps<Theme> = {
    height: '3px',
    background: `linear-gradient(90deg, ${theme.palette.brand.main} 0%, ${theme.palette.brand.light} 100%)`,
};

export const headerSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    flexWrap: 'wrap',
    px: 3,
    py: 2.25,
    background: 'linear-gradient(180deg, #FEF3F6 0%, #FFFFFF 100%)',
};

export const badgeSx: SxProps<Theme> = {
    width: '38px',
    height: '38px',
    borderRadius: '10px',
    background: `linear-gradient(135deg, #FFE8EB 0%, ${theme.palette.brand.light} 100%)`,
    color: theme.palette.brand.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {fontSize: '21px'},
};

export const labelSx: SxProps<Theme> = {
    fontSize: '0.625rem',
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: theme.palette.neutral[500],
};

export const nameSx: SxProps<Theme> = {
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.brand.dark,
    textDecoration: 'none',
    display: 'inline-block',
    '&:hover': {textDecoration: 'underline'},
};

export const factsSx: SxProps<Theme> = {
    display: 'grid',
    gridTemplateColumns: {xs: '1fr', sm: 'repeat(3, 1fr)'},
    borderTop: `1px solid ${theme.palette.neutral[100]}`,
};

export const factSx: SxProps<Theme> = {
    px: 3,
    py: 2.5,
    borderRight: `1px solid ${theme.palette.neutral[100]}`,
    '&:last-of-type': {borderRight: 'none'},
};

export const factValueSx: SxProps<Theme> = {
    fontSize: '0.875rem',
    fontWeight: 500,
    mt: 0.4,
};

/** The fee, printed once, in the accent the plan owns. */
export const feeSx: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'baseline',
    gap: 0.6,
    mt: 0.25,
};

export const feeCurrencySx: SxProps<Theme> = {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: theme.palette.brand.main,
};

export const feeAmountSx: SxProps<Theme> = {
    fontSize: '1.5rem',
    fontWeight: 600,
    letterSpacing: '-0.02em',
    lineHeight: 1,
    color: theme.palette.brand.main,
    fontVariantNumeric: 'tabular-nums',
};

export const feePeriodSx: SxProps<Theme> = {
    fontSize: '0.75rem',
    color: theme.palette.neutral[500],
};

/** An outlined button in the plan's own colour rather than the page's blue. */
export const openPlanButtonSx: SxProps<Theme> = {
    ...(actionButtonSx('32px', 'secondary') as object),
    color: theme.palette.brand.dark,
    border: `1px solid ${theme.palette.brand.light}`,
    '&:hover': {
        background: '#FEF3F6',
        border: `1px solid ${theme.palette.brand.main}`,
        boxShadow: 'none',
    },
};
